import moment from 'moment';

export const INIT = {
    requiredInformation: {
        dpaName: 'สัญญาประมวลผลข้อมูลส่วนบุคคล (Data Processing Agreement )',
        contractDate: moment(),
        ownerCompanyName: '',
        ownerCompanyAddress: '',
        ownerFullName: '',
        ownerPosition: '',
        counterpartyCompanyName: '',
        counterpartyCompanyAddress: '',
        counterpartyFullName: '',
        counterpartyPosition: '',
        mainContractName: '',
        purpose: '',
        personalData: '',
        frequencyForSendRopa: '',
        amtDestroyData: '',
        trackUsage: '',
        dpaPolicyDataSubjectType: [],
    },
    documentContent: {
        dpaDetailDocument: '',
    },
};
